<template>
  <SkeletonAnimation>
    <div class="efocate-skeleton-component">
      <div class="cate-container">
        <div class="back"></div>
        <div class="banner">
          <PartItem
            :styles="{
              width: '620px',
              height: '40px',
              'border-radius': '4px',
              'margin-bottom': '20px',
              'margin-top': '100px',
            }"
          />
          <PartItem
            :styles="{
              width: '260px',
              height: '24px',
              'border-radius': '4px',
            }"
          />
        </div>
        <div class="cate-list" v-for="index in 10" :key="index">
          <PartItem
            :styles="{
              width: '200px',
              height: '200px',
              'border-radius': '4px',
              'margin-bottom': '16px',
            }"
          />
          <PartItem
            :styles="{
              width: '200px',
              height: '16px',
              'border-radius': '4px',
              'margin-bottom': '10px',
            }"
          />
          <div class="flex">
            <PartItem
              :styles="{
                width: '100px',
                height: '15px',
                'border-radius': '4px',
              }"
            />
            <PartItem
              :styles="{
                width: '72px',
                height: '32px',
                'border-radius': '4px',
                'margin-bottom': '16px',
              }"
            />
          </div>
          <div class="line"></div>
          <PartItem
            :styles="{
              width: '200px',
              height: '12px',
              'border-radius': '4px',
            }"
          />
        </div>
      </div>
    </div>
  </SkeletonAnimation>
</template>
<script>
import SkeletonAnimation from '../../SkeletonAnimation';
import PartItem from '../partItem.vue';

export default {
  name: 'EfocateSkeleton',
  components: {
    SkeletonAnimation,
    PartItem,
  },
  data() {
    return {
      block1: {
        width: '36px',
        height: '36px',
        background: '#E5E5EB',
        'border-radius': '4px',
        'margin-right': '10px',
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.efocate-skeleton-component {
  .back {
    width: 160px;
    height: 20px;
    background: #e5e5eb;
    position: absolute;
    top: 24px;
    left: -100px;
    border-radius: 4px;
  }
  .banner {
    height: 280px;
    margin-bottom: 10px;
    width: 100%;
    margin-left: 10px;
  }
  .cate-container {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 1156px;
    margin: 0 auto;
  }
  .cate-list {
    padding-top: 8px;
    box-sizing: border-box;
    width: 215px;
    height: 349.37px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 20px;
  }
  .flex {
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .line {
    width: 200px;
    height: 1px;
    background: #f5f5f5;
    margin-bottom: 10px;
  }
}
</style>
